<template>
  <div class="ut-campo">
    <v-checkbox v-if="campo.tipo === 'booleano' && !filtro" :input-value="value === true" :label="campo.titulo"
      :disabled="disabled" dense hide-details @change="$emit('input', $event)" />
    <v-autocomplete v-else-if="campo.catalogo || campo.tipo === 'select' || campo.tipo === 'booleano' || (campo.opciones && campo.opciones.length)"
      :value="value" :items="items" item-text="titulo" item-value="valor" :label="campo.titulo" :disabled="disabled"
      dense outlined hide-details clearable no-data-text="Sin opciones" @input="$emit('input', $event === null ? '' : $event)" />
    <v-textarea v-else-if="campo.tipo === 'textarea'" :value="value" :label="campo.titulo" :disabled="disabled"
      rows="3" auto-grow outlined dense hide-details :maxlength="campo.maxlength || 4000" @input="$emit('input', $event)" />
    <v-text-field v-else :value="value" :label="campo.titulo" :disabled="disabled" :type="tipo"
      :min="campo.min" :max="campo.max" :step="campo.entero ? 1 : 'any'" :maxlength="campo.maxlength || 300" dense outlined hide-details
      @input="$emit('input', $event)" />
  </div>
</template>

<script>
export default {
  name: 'CampoUtilitario',
  props: { campo: { type: Object, required: true }, value: { default: '' }, catalogos: { type: Object, default: () => ({}) }, disabled: Boolean, filtro: Boolean },
  computed: {
    tipo() { return this.campo.tipo === 'fecha' ? 'date' : ['numero', 'moneda'].includes(this.campo.tipo) ? 'number' : 'text'; },
    items() {
      if (this.campo.catalogo) return this.catalogos[this.campo.catalogo] || [];
      if (this.campo.tipo === 'booleano') return [{ valor: true, titulo: 'Si' }, { valor: false, titulo: 'No' }];
      return this.campo.opciones || [];
    },
  },
};
</script>

<style scoped>
.ut-campo { min-width: 0; }
.ut-campo >>> .v-label { max-width: 100%; font-size: 13px; letter-spacing: 0; }
.ut-campo >>> .v-input--checkbox { margin-top: 0; padding-top: 4px; }
.ut-campo >>> .v-input--checkbox .v-label { white-space: normal; overflow-wrap: anywhere; line-height: 1.4; }
.ut-campo >>> input, .ut-campo >>> textarea { font-size: 14px; letter-spacing: 0; }
</style>
